import { useQueryClient } from "@tanstack/react-query";
export const useInvalidateOrgQueries = ()=>{
    const queryClient = useQueryClient();
    const invalidateAllOrgQueries = async ()=>{
        const predicate = (query)=>{
            const key = query.queryKey[0];
            return [
                'apiKeys',
                'contracts',
                'invoices',
                'invoice',
                'meteredUsage',
                'dailyUsage',
                'hourlyUsage',
                'organizationUsers',
                'products'
            ].includes(key);
        };
        queryClient.removeQueries({
            predicate
        });
    };
    return {
        invalidateAllOrgQueries
    };
};
